import moment from 'moment-timezone'
export default {
  name: 'localDateTime',
  filter: function (value, format, inclTimezone) {
    if (format === '') format = 'MM/DD/YYYY hh:mm a '
    if (!value) return
    const zoneName = moment.tz.guess(true)
    const zone = moment.tz(zoneName)
    const abbrZone = zone.zoneAbbr()
    const canAbbreviate = abbrZone.match(/[A-Za-z]/)
    if (!canAbbreviate && inclTimezone) {
      const timeZoneOffsetInMinutes = zone._offset
      let absTimeZoneOffsetInMinutes = Math.abs(timeZoneOffsetInMinutes)
      let hours = Math.floor(absTimeZoneOffsetInMinutes / 60)
      let minutes = absTimeZoneOffsetInMinutes % 60
      if (minutes === 0) minutes = '00'
      if (hours < 10) hours = `0${hours}`
      const sign = abbrZone[0]
      const hourMinFormatInUTC = `UTC ${sign}${hours}:${minutes}`
      return moment.utc(value).local().format(format).concat(hourMinFormatInUTC)
    }
    const formatWithZone = inclTimezone ? `${format}z` : format
    return moment.utc(value).local().tz(zoneName).format(formatWithZone)
  }
}
